export default "__VITE_ASSET__CUai1pao__"